import React from 'react';
import './SectionHeader.css';

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon, title, subtitle }) => {
  return (
    <div className="section-header">
      <div className="section-header-content">
        <div className="section-header-icon">{icon}</div>
        <div className="section-header-text">
          <h2 className="section-header-title">{title}</h2>
          {subtitle && <p className="section-header-subtitle">{subtitle}</p>}
        </div>
      </div>
      <div className="section-header-divider" />
    </div>
  );
};
